class PredictiveSearch extends Theme.Component {
  constructor() {
    super();

    this.modal = this.querySelector('[data-predictive-search-modal]');
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearch = this.querySelector('[data-predictive-search]');
    this.cachedResults = {};
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
  }

  connectedCallback() {
    document.addEventListener("searchlink:click", () => this.show());
    document.addEventListener("predictivesearch:close", () => this.hide());

    const closeButton = this.querySelector('[data-predictive-modal-close]');
    if (closeButton) {
      closeButton.addEventListener("click", () => this.hide());
    }

    const clearButton = this.querySelector('button[data-predictive-search-clear]');
    if (clearButton && this.input) {
      clearButton.addEventListener('click', () => {
        this.input.value = '';
        this.predictiveSearch.innerHTML = '';
        this.input.focus();
      });
    }

    if (this.input) {
      this.input.addEventListener('input', this._debounce(this.onChange.bind(this), 300));
    }

    this.addEventListener('focusout', this.onFocusOut.bind(this));
  }

  onChange(event) {
    const newSearchTerm = event.target.value.trim();

    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      const staleResults = this.querySelector("[data-predictive-search-results-wrapper]");
      if (staleResults) {
        staleResults.remove();
      }
    }

    this.searchTerm = newSearchTerm;

    if (this.searchTerm.length) {
      this.getSearchResults(this.searchTerm);
    } else {
      this.predictiveSearch.innerHTML = '';
    }
  }

  getSearchResults(query) {
    const queryKey = query.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }
    const url = `/search/suggest?q=${encodeURIComponent(query)}&${encodeURIComponent('resources[limit]')}=10&section_id=predictive-search`;

    fetch(url)
      .then((res) => {
        if (!res.ok) throw new Error(`Fetch failed with status ${res.status}`);
        return res.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const results = doc.querySelector('#shopify-section-predictive-search');
        if (results) {
          this.allPredictiveSearchInstances.forEach((instance) => {
            instance.cachedResults[queryKey] = results.innerHTML;
          });
          this.renderSearchResults(results.innerHTML);
        }
      })
      .catch((err) => {
      });
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearch.innerHTML = resultsMarkup;
    if (window.alignProductCardsHeight) alignProductCardsHeight();

    const allResultsButton = this.querySelector('[data-predictive-all-results]');
    if (allResultsButton && this.input) {
      allResultsButton.addEventListener('click', () => {
        const query = this.input.value.trim();

        if (query.length) {
          const searchUrl = `/search?q=${encodeURIComponent(query)}`;
          window.location.href = searchUrl;
        }
      });
    }
  }

  _debounce(fn, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  show() {
    if (this.modal) {
      this.modal.classList.add("visible");
      document.body.classList.add("no-scroll");
      if (this.input) this.input.focus();
    }
  }

  hide() {
    if (this.modal) {
      this.modal.classList.remove("visible");
      document.body.classList.remove("no-scroll");
    }
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(text) {
    if (!this.statusElement) return;
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = text;
    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  onFocusOut(event) {
    setTimeout(() => {
      const activeEl = document.activeElement;

      const isModalStillFocused = this.contains(activeEl);
      const isFocusNowOnBody = activeEl === document.body;

      if (!isModalStillFocused && !isFocusNowOnBody) {
        this.hide();
      }
    });
  }
}

customElements.define("predictive-search", PredictiveSearch);